import * as React from 'react';
import { useLocation } from 'react-router';

import { TextLink } from '../../../components/ClickableText';

import { FullTeamFragment } from '../../../generated/graphql';
import { paths } from '../../../paths';
import { useAuth } from '../../../contexts/AuthContext';
import { isNil } from '../../../utils/isNil';
import { withIntendedPath } from '../../../utils/withIntendedPath';

interface Props {
  team: Pick<FullTeamFragment, 'name' | 'id'>;
  matchId?: string;
}

export const JoinTeamPrompt: React.FC<Props> = ({ team }) => {
  const { pathname, search } = useLocation();
  const { user } = useAuth();

  return (
    <div className="p-4 text-sm text-center space-y-2">
      <h3 className="font-semibold">
        Are you a regular player for {team.name}?
      </h3>
      <p>
        <TextLink
          to={withIntendedPath(paths.register(), paths.joinTeam.team(team.id))}
        >
          Join this team
        </TextLink>{' '}
        to read votes, check future matches, and connect with your club.
      </p>

      {isNil(user) ? (
        <p>
          Or, if you're already a player on the team,{' '}
          <TextLink
            to={withIntendedPath(paths.signIn(), `${pathname}${search}`)}
          >
            sign in
          </TextLink>{' '}
          to see more.
        </p>
      ) : null}
    </div>
  );
};
